import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BiShieldX, BiErrorCircle } from "react-icons/bi";

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <Card className="text-center shadow-lg p-4 border-danger rounded-4" style={{ maxWidth: "500px" }}>
                <Card.Body>
                    <div className="text-danger display-4 mb-3">
                        <BiShieldX />
                    </div>
                    <h1 className="text-danger fw-bold">403</h1>
                    <h3 className="fw-bold mb-3">Unauthorized Access</h3>

                    <p className="text-muted d-flex align-items-start justify-content-center gap-2 fs-5">
                        <BiErrorCircle className="text-warning mt-1" />
                        Sorry, you do not have permission to view this page.
                    </p>

                    <Button variant="danger" className="mt-3 px-4 py-2" onClick={() => navigate("/")}>
                        Go to Login
                    </Button>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Unauthorized;

